export default {
  name: 'AdnBreadcrumbs',
  data() {
    return {
      /* Current page should not be include in structured data:
       * https://developers.google.com/search/docs/data-types/breadcrumb
       */
      displayLastItemWithStructuredData: false
    }
  },
  props: {
    breadcrumbs: {
      type: Array,
      default: undefined
    }
  },
  computed: {
    hasBreadcrumbs() {
      return this.breadcrumbs !== undefined && Array.isArray(this.breadcrumbs) && this.breadcrumbs.length > 0
    }
  },
  methods: {
    displayItemWithStructuredData(index) {
      return this.displayLastItemWithStructuredData || index + 1 < this.breadcrumbs.length
    }
  }
}
